export default {
  delete_success: 'Das Angebot wurde erfolgreich gelöscht',
  delete_failed: 'Das Löschen des Angebots ist fehlgeschlagen',
  delete_confirm_title: 'Sind Sie sicher, dass Sie dieses Angebot löschen möchten?',
  delete_last_day_confirm_title:
    'Wenn Sie den letzten verbleibenden Tag entfernen, wird dieses Angebot gelöscht. Sind Sie sicher?',
  confirm: 'Bestätigen',
  cancel: 'Abbrechen',
  qualifying_items: 'Qualifizierende Artikel',
  free_items: 'Gratisartikel',
  all_day: 'Ganztägig',
  starts_on: 'Beginnt am {{date}}',
  ends_on: 'Endet am {{date}}',
  ends_when_deleted: 'Endet, wenn gelöscht',
  off: '{{amount}} Rabatt',
  min_spend_value: 'Mindestumsatz: {{amount}}',
};
